import { render } from "./NoticeDialog.vue?vue&type=template&id=3ce6276b&scoped=true"
import script from "./NoticeDialog.vue?vue&type=script&lang=js"
export * from "./NoticeDialog.vue?vue&type=script&lang=js"

import "./NoticeDialog.vue?vue&type=style&index=0&id=3ce6276b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce6276b"]])

export default __exports__